<template>
  <div class="body-container scanner">
    <i class="fas fa-align-left img-fill"></i>
    <i class="fas fa-qrcode"></i>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
  .scanner {
    display: flex;
    flex-direction: column;
-webkit-flex-direction: column;
    justify-content: space-around;
    -webkit-display: flex;
    -webkit-flex-direction: column;
-webkit-flex-direction: column;
    -webkit-justify-content: space-around;
    width: 100%;
    height: 100%;
    box-shadow: 0px 2px 10px 0px rgba($color: #000000, $alpha: .35);
    border-radius: 5px;
    -webkit-border-radius: 5px;

    i {
      display: inline-block;
      font-size: 70px;
      max-width: 150px;
      max-height: 150px;

      @media screen and (max-width: 1024px) {
        font-size: 100px;
      }

      @media screen and (max-width: 750px) {
        font-size: 100px;
      }

      @media screen and (max-width: 540px) {
        font-size: 80px;
      }

      @media screen and (max-width: 360px) {
        font-size: 60px;
      }

      @media screen and (max-width: 320px) {
        font-size: 55px;
      }

      &.img-fill {
        font-size: 80px;
        transform: scaleX(2.2);
        -webkit-transform: scaleX(2.2);
        color: gray;

        @media screen and (max-width: 1024px) {
          font-size: 110px;
          transform: scaleX(2.3);
          -webkit-transform: scaleX(2.3);
        }

        @media screen and (max-width: 750px) {
          font-size: 100px;
          transform: scaleX(2.2);
          -webkit-transform: scaleX(2.2);
        }

        @media screen and (max-width: 540px) {
          font-size: 80px;
          transform: scaleX(2.1);
          -webkit-transform: scaleX(2.1);
        }

        @media screen and (max-width: 360px) {
          font-size: 65px;
          transform: scaleX(2.1);
          -webkit-transform: scaleX(2.1);
        }

        @media screen and (max-width: 320px) {
          font-size: 65px;
          transform: scaleX(2);
          -webkit-transform: scaleX(2);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/scan/QrCodeScanner.vue